import dayjs from "dayjs";
import { LeaseTerms } from "../../../types/bookings";

export const getRentFreePeriodValue = (leaseTerms?: LeaseTerms): string | undefined => {
  if (!leaseTerms) return undefined;

  const { rentFreePeriod, rentFreeStartDate, rentFreeEndDate } = leaseTerms;

  if (rentFreePeriod) return rentFreePeriod;

  if (rentFreeStartDate && rentFreeEndDate) {
    const diffDays = dayjs(rentFreeEndDate).diff(dayjs(rentFreeStartDate), "days");
    return String(diffDays);
  }

  return undefined;
};
